import { NacoService } from '../domains/services/naco.service';
import { Config } from '../domains/values/config';
import { Router } from '@angular/router';
import { Storage } from '@ubud/storage';
import { InjectionToken } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Location } from '@angular/common';

export function nacoFactory(config: object, router: Router, storage: Storage, http: HttpClient, location: Location) {
    return new NacoService(
        new Config({ ...config }),
        router,
        storage,
        http,
        location
    );
}

export const NACO_CONFIG = new InjectionToken<object>('NACO_CONFIG');
